/*  

Description: Theme JS
Version: 1.0
Author: BeeSoft - Web & Mobile Solutions
Author URI: http://www.beesoft.it

*/

/*** NAV ***/

function handleNav() {
	
	// on scroll
	$(window).scroll(function() {
		
		var wscroll = $(this).scrollTop();
		
		// scrolling
		if (wscroll > 100) $('body').addClass('scrolling');
		else $('body').removeClass('scrolling');
		
	});
	
	// scrollto
	$(document).on('click', '.scrollto', function(e) { 
		
		e.preventDefault();
		
		var mypos = $($(this).attr('href')).offset(); 
		if (mypos) $('html, body').animate({ scrollTop: mypos.top }, 600);
		
	});
	
	// main-nav
	$(document).on('click', '#tgl-main-nav', function(e) { 
		
		if ($('body').hasClass('main-nav-open')) {
			
			$(this).text( $(this).attr('data-text-open') );
			$('body').removeClass('main-nav-open');
			
		}
		else {
			
			$(this).text( $(this).attr('data-text-close') );
			$('body').addClass('main-nav-open');
		
		}
		
	});
  
  // main-nav links
	$(document).on('click', '#main-nav .nav-link', function(e) { 
		
      if ($('body').hasClass('main-nav-open')) {
        
        setTimeout(function(){
          $('body').removeClass('main-nav-open');
          $('#main-nav').removeClass('show');
        }, 500);
        
      }
		
	});
	
}


/*** COUNTDOWN ***/

function handleCountDown() {
	
	if ( $('.countdown').length ) {
		
		$('.countdown').each(function() {
			
			var countdownContainer = $(this);
			
			var countDate = countdownContainer.attr('data-datecount');
			var countFinishText = countdownContainer.attr('data-finishtext');
			
			const textd = $(this).attr('data-textd');
			const texth = $(this).attr('data-texth');
			const textm = $(this).attr('data-textm');
			const texts = $(this).attr('data-texts');
			
			if ( countDate ) {
		
				var countDownDate = new Date( countDate ).getTime();
				
				var x = setInterval(function() {
				
					var now = new Date().getTime();
					
					var distance = countDownDate - now;
					
					var days = Math.floor(distance / (1000 * 60 * 60 * 24));
					var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					var seconds = Math.floor((distance % (1000 * 60)) / 1000);
					
					var countDownText = `<span class="value">${ days }<sub>${ textd }</sub></span>
					<span class="value">${ hours }<sub>${ texth }</sub></span>
					<span class="value">${ minutes }<sub>${ textm }</sub></span>
					<span class="value">${ seconds }<sub>${ texts }</sub></span>`;
					
					countdownContainer.html( countDownText );
					
				}, 1000);
			
			}
			
		});
	
	}
	
}


/*** LINE UP ***/

function apiRequest( endpoint, method, params ) {
			
	console.log( 'API:', endpoint, method );
	
	if ( params ) console.log( 'Params:', params );
	
	let headers = {
        "Content-Type": "application/json"
    };
	
	return fetch( endpoint, {
		method: method,
		headers: headers,
		body: JSON.stringify( params )
	} )
	.then( resp => {
		
		return resp.json();
		
	} );

}

async function getArtistDetails( id ) {
	
	console.log( 'Artist ID:', id );
	
	if ( id != null ) {	
		
		const calendarElem = $('#area-calendar');
		const artistElem = $('#area-artist');
			
		try {
			
			const artistURL = calendarElem.attr('data-lineup');
			
			if ( artistURL ) {
			
				const apiData = await apiRequest( artistURL + id, 'GET' );
				
				console.log( 'apiData:', apiData );
				
				if ( apiData.error ) {
					
					console.log( 'API Error:', apiData.error );
					
				}
				else {
					
					artistElem.find('.artist-name').html( apiData.name );
					artistElem.find('.artist-country').html( apiData.country );
					artistElem.find('.artist-genre').html( apiData.genre );
					artistElem.find('.artist-description').html( apiData.description );
					
					//if ( artistElem.find('.artist-gallery .gallery-item').length > 1 ) $('.single-slider').slick('unslick');
					
					let members = '';
					
					for ( let k = 0; k < apiData.members.length; k++ ) {
					
						members += `<li class="list-group-item"><strong>${ apiData.members[ k ].name }</strong> - ${ apiData.members[ k ].instrument }</li>`;
					
					}
					
					artistElem.find('.artist-members').html( members );
					
					let gallery = '';
					
					apiData.gallery.reverse();
					
					/*
					for ( let k = 0; k < apiData.gallery.length; k++ ) {
					
						gallery += `<div class="gallery-item"><a href="${ apiData.gallery[ k ] }"><img src="${ apiData.gallery[ k ] }"/></a></div>`;
					
					}
					*/

					gallery = `<div class="gallery-item"><a href="${ apiData.gallery[ 0 ] }"><img src="${ apiData.gallery[ 0 ] }"/></a></div>`;
					
					artistElem.find('.artist-gallery').html( gallery );
					
					/*
					if ( apiData.gallery.length > 1 ) {
						
						$('.single-slider').slick({
							infinite: true,
							arrows: true,
							dots: false,
							autoplay: false
						});
					
					}
					*/
					
					artistElem.find('.artist-gallery a').fancybox();
					
					let links = '';
					
					for ( let k = 0; k < apiData.links.length; k++ ) {
						
						if ( apiData.links[ k ].url ) {
						
							let img = '';
							
							if ( apiData.links[ k ].type === 'fb' ) img = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-facebook" viewBox="0 0 20 20"><path fill="currentColor" d="M18.05.811q.439 0 .744.305t.305.744v16.637q0 .439-.305.744t-.744.305h-4.732v-7.221h2.415l.342-2.854h-2.757v-1.83q0-.659.293-1t1.073-.342h1.488V3.762q-.976-.098-2.171-.098-1.634 0-2.635.964t-1 2.72V9.47H7.951v2.854h2.415v7.221H1.413q-.439 0-.744-.305t-.305-.744V1.859q0-.439.305-.744T1.413.81H18.05z"/></svg>`;
							
							if ( apiData.links[ k ].type === 'ins' ) img = `<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram" class="svg-inline--fa fa-instagram fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>`;
							
							if ( apiData.links[ k ].type === 'spot' ) img = `<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="spotify" class="svg-inline--fa fa-spotify fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"></path></svg>`;
							
							if ( apiData.links[ k ].type === 'web' ) img = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="window" class="svg-inline--fa fa-window fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-336 96c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm96 0c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm96 0c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32z"></path></svg>`;
						
							links += `<a class="nav-link" href="${ apiData.links[ k ].url }" target="_blank">${ img }</a>`;
						
						}
					
					}
					
					artistElem.find('.artist-links').html( links );
					
					const video = apiData.video[0].url;
					
					artistElem.find('.artist-video').attr( 'href', video );
					
					artistElem.addClass('show');
					
					const mypos = artistElem.offset(); 
					
					if ( mypos ) $('html, body').animate( { scrollTop: mypos.top }, 600 );
					
				}
			
			}
			
		} catch( err ) {
			
			console.log( 'Error:', err );
		
		}
	
	}
	
}

async function handleLineUp() {
	
	// calendar
	
	/*
	const calendarElem = $('#area-calendar');
	
	if ( calendarElem.length ) {
	
		$('body').addClass('loading');
			
		try {
			
			const lineupURL = calendarElem.attr('data-lineup');
			
			if ( lineupURL ) {
			
				const apiData = await apiRequest( lineupURL, 'GET' );
				
				console.log( 'apiData:', apiData );
				
				if ( apiData.error ) {
					
					console.log( 'API Error:', apiData.error );
					
				}
				else {
					
					let index = 1;
					
					for ( date in apiData ) { 
						
						const shows = apiData[ date ].lineup;
						const booking = apiData[ date ].booking;
						
						const itemDate = new Date( date );
						const day = itemDate.getDate();
						
						calendarElem.find('.calendar-selector .row').append( 
							`<div class="col">
								
								<div class="calendar-item">
									<a href="#d${ index }" class="d" data-toggle="collapse" ${ index == 1 ? 'aria-expanded="true"' : '' }>${ day }</a>								
								</div>
								
							</div>`
						);	
						
						let programCols = '';
						
						for ( let k = 0; k < shows.length; k++ ) {
							
							let showGroup = '';
                          	const currentShow = shows[ k ];
                          	
                          	let hasCustomBookingLink = false;
                          	
                          	if ( currentShow.booking.url ) hasCustomBookingLink = true;
                          	
                          	const customBookingLink = hasCustomBookingLink ? currentShow.booking.url : booking.link;

                          
							for ( let j = 0; j < shows[ k ].program.length; j++ ) {
								
								showGroup += `<div class="exhib" onclick="getArtistDetails( ${ shows[ k ].program[ j ].artist.id } )">
												<p>${ shows[ k ].program[ j ].time }</p>
												<h6>${ shows[ k ].program[ j ].artist.name }</h6>
											</div>`;
								
							}
							
							let placeCover = '';
							
							if ( shows[ k ].place.cover ) placeCover = `<div class="cover"><a href="${ customBookingLink }" target="_blank"><img src="${ shows[ k ].place.cover }"/></a></div>`;
							
							const placeName = `<h5><a href="${ customBookingLink }" target="_blank">${ shows[ k ].place.name }</a></h5>`;
							const placeNameBooking = `<br/><br/><a href="${ customBookingLink }" class="btn btn-sm btn-primary"  target="_blank">${ shows[ k ].place.name }</a>`;
							
							programCols += `<div class="col">
											
											<div class="place">
												${ placeCover }
												${ hasCustomBookingLink ? '' : placeName }
												<p><a href="https://maps.google.com?q=${ shows[ k ].place.address }" target="_blank">${ shows[ k ].place.address }</a></p>
											</div>
											
											${ showGroup }
											
											${ hasCustomBookingLink ? placeNameBooking : '' }
											
										</div>`;
							
						}
						
						let bookingBtn = '';
						
						if ( booking.link && booking.label ) {
							
							bookingBtn = `<div class="area-action">
									<a href="${ booking.link }" class="btn btn-sm btn-primary" target="_blank">${ booking.label }</a>
								</div>`;
							
						}
						
						let blockText = '';
						
						if ( booking.condizioni ) {
							
							blockText = `<div class="area-text">${ booking.condizioni }</div>`;
							
						}
						
						calendarElem.find('.calendar-items').append( 
							`<div id="d${ index }" class="calendar-item-content collapse ${ index == 1 ? 'show' : '' }" data-parent="#area-calendar">
								<div class="d">${ day }</div>		
								<div class="container">							
									<div class="row ${ shows.length > 1 ? 'row-cols-4' : 'row-full' } ">
									
										${ programCols }
										
									</div>	
									
									${ bookingBtn }
									
									${ blockText }
									
								</div>							
							</div>`
						);		
						
						index++;
					
					}			
					
					
				}
				
				$('body').removeClass('loading');
			
			}
			
		} catch( err ) {
			
			console.log( 'Error:', err );
			
			$('body').removeClass('loading');
		
		}
		
		// day click
		$( document ).on( 'click', '#area-calendar .d', function() {
			
			$('#area-artist').removeClass('show');
			
			//if ( $('.single-slider .gallery-item').length > 1 ) $('.single-slider').slick('unslick');
			
		} );
	
	}
	*/
	
	// grid
	
	const gridElem = $('#area-grid');
	
	if ( gridElem.length ) {
	
		$('body').addClass('loading');
			
		try {
			
			const lineupURL = gridElem.attr('data-artists');
			
			if ( lineupURL ) {
			
				const apiData = await apiRequest( lineupURL, 'GET' );
				
				console.log( 'apiData:', apiData );
				
				if ( apiData.error ) {
					
					console.log( 'API Error:', apiData.error );
					
				}
				else {
					
					let grid = '';
					
					for ( let k = 0; k < apiData.length; k++ ) {
						
						grid += `<div class="col-md-4">
							
							<div class="artist-item" onclick="getArtistDetails( ${ apiData[k].id } )">
								<img src="${ apiData[k].cover }"/>
								<h5 class="d-flex justify-content-center align-items-center">${ apiData[k].name }</h5>
							</div>
							
						</div>`; 
						
					}
					
					gridElem.find('.artists-list').append( grid );
					
				}
				
				$('body').removeClass('loading');
			
			}
			
		} catch( err ) {
			
			console.log( 'Error:', err );
			
			$('body').removeClass('loading');
		
		}
	
	}
	
}


/*** PRODUCTS ***/

function showVariantImg( var_id ) {
 
  const gal_index = $('#prodGallery').find('.product-gallery-item[data-variant="'+ var_id +'"]').index('#prodGallery .product-gallery-item');
  
  if ( gal_index != -1 ) $('.product-gallery').slick('slickGoTo', gal_index);
  
}

function handleProducts() {
  
  // init gallery
  
  let default_var_id = $('#prodVariants').val();
  
  if ( default_var_id ) showVariantImg( default_var_id );
  
  // variant change  
  $('#prodVariants').on('change', function() {
    
    const var_id = $(this).val();
    const var_price = $('option:selected', this).attr('data-price');
    
    $('#prodPrice').html( var_price );
    
    showVariantImg( var_id );
    
  });
  
  // product quantity change
  $('#prodQuantity').on('change', function() {
    
    const qty = $(this).val();
    
    const prod_price = $('#prodPrice').attr('data-price');
    const tot_price = ( prod_price * qty ) / 100;
    
    $('#prodPrice').html( new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format( tot_price ) );
    
  });
  
  // cart quantity change
  $('#frm-cart .qty').on('change', function() {
    
    const qty = $(this).val();
    const line_index = $(this).attr('data-quantity-item');
    
    const current_line = $(this).parents('[data-line="'+ line_index +'"]');
    
    const prod_price = current_line.find('[data-lineprice]').attr('data-lineprice');
    const line_tot_price = ( prod_price * qty ) / 100;
    
    current_line.find('[data-linetot]').attr('data-linetot', line_tot_price * 100);
    current_line.find('.line-tot').html( new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format( line_tot_price ) );
    
    let tot_price = 0;
    
    $('#frm-cart [data-linetot]').each( function() {
      
      tot_price += Number( $(this).attr('data-linetot') );
      
    });
    
    $('#totalPrice').html( new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format( tot_price / 100 ) );
    
  });
  
}

/*** ON LOAD ***/

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function deleteCookie(name){
  setCookie(name, '', -1);
}

var mobileDevice = false;

function forceDownload(blob, filename) {
  var a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  // For Firefox https://stackoverflow.com/a/32226068
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function downloadResource(url, filename) {
  if (!filename) filename = url.split('\\').pop().split('/').pop();
  fetch(url, {
      headers: new Headers({
        'Origin': location.origin
      }),
      mode: 'cors'
    })
    .then(response => response.blob())
    .then(blob => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    })
    .catch(e => console.error(e));
}

$(function() {
	
	// mobile device
	if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		
		mobileDevice = true;
		
		$('body').addClass('mobile-device');
		
		console.log('Mobile Device', mobileDevice);
	
	}
	
	$('html, body').animate({ scrollTop: 0 }, 100);
	
	setTimeout(function() {
		    	
    	$('body').removeClass('loading');
    	
	    // hash handle
	    if (window.location.hash) {
		    
		    var mypos = $(window.location.hash).offset(); 
			if (mypos) $('html, body').animate({ scrollTop: mypos.top }, 600);
		    
	    }
	    
	    // nav
	    handleNav();
	    
    }, 600);
    
    // countdown
    handleCountDown();
    
    // line up
    handleLineUp();
	
	// gallery-slider
	$('.gallery-slider').slick({
		infinite: true,
		arrows: false,
		dots: true,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false
	});
	
	// carousel-slider
	$('.carousel-slider').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		autoplay: false,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}			
		]
	});

   $('.images-slideshow').slick({
		infinite: true,
      centerPadding: '20svw',
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		autoplay: 1,
      centerMode: true,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
               centerPadding: '24px',
				}
			}			
		]
	});

   $('.cards-grid').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		autoplay: 1,
      mobileFirst: true,
		responsive: [
			{
				breakpoint: 992,
				settings: "unslick"
			}			
		]
	});

   
	
	$('.carousel-slider-arrows .slick-next').on('click', function() {
		
		$('.carousel-slider').slick('slickNext');
		
	});
	
	$('.carousel-slider-arrows .slick-prev').on('click', function() {
		
		$('.carousel-slider').slick('slickPrev');
		
	});
  
  	// quote-slider
	$('.quote-slider').slick({
		infinite: true,
		arrows: false,
		dots: true,
		autoplay: true,
		autoplaySpeed: 6000,
      	slidesToShow: 1,
		pauseOnHover: true
	});
	
	// block-slider
	$('.block-slider').slick({
		infinite: true,
		arrows: false,
		dots: true,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: true
	});
	
	// product-gallery
	$('.product-gallery').slick({
		infinite: false,
		arrows: true,
		dots: false,
		autoplay: false
	});
	
	// timeline-slider
	const timelineSlider = $('.timeline-slider');
	
	timelineSlider.slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		autoplay: false
	});
	
	$(document).on('click', '.timeline-slider .y', function() {
		
		const index = $(this).index( '.timeline-slider .y' );
		
		timelineSlider.slick( 'slickGoTo', index );
		
	});
  
  	// products
  	handleProducts();
  
  	//logo sponsor
  	var sponsorLogosSlideshow = $('.sponsor-logos-slideshow');
    if( sponsorLogosSlideshow.length ){
      sponsorLogosSlideshow.slick({
          infinite: true,
          arrows: true,
          dots: false,
          autoplay: false,
          rows: 2,
          slidesPerRow: 3
      });
    }const downloadLinks = document.querySelectorAll('a[download]');
   console.log('v', downloadLinks);
   if( downloadLinks.length )
   {
    [...downloadLinks].forEach(function(el){
        el.addEventListener('click', function(event){
            event.preventDefault();
            const downloadUrl = event.target.href.split(/[?#]/)[0];
            downloadResource(downloadUrl);
        }, false);
    });
   }
});

document.addEventListener('DOMContentLoaded', function () {
   const details = document.querySelectorAll('details.daily-lineup');

   if (details.length > 0) {
      [...details].forEach(function (el) {
         const summary = el.querySelector('summary');

         if (!summary) return;

         summary.addEventListener('click', function (event) {
            event.preventDefault();

            const isOpen = el.hasAttribute('open');

            // Chiude tutti
            details.forEach(d => d.removeAttribute('open'));

            // Se quello cliccato era chiuso, lo apriamo
            if (!isOpen) {
               el.setAttribute('open', true);
            }
         }, false);
      });
   }
});
